import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="output-patterns--table"
export default class extends Controller {
  static targets = ["row"];
  
  connect() {
  }

  activateRow(event) {
    // remove "active" from all pattern items
    this.rowTargets.forEach(row => {
      row.querySelectorAll(".pattern-item").forEach(item => {
        item.classList.remove("active");
      });
    });

    // add "active" to the clicked row's pattern item
    const currentRow = event.currentTarget;
    const item = currentRow.querySelector(".pattern-item");

    if (item) {
      item.classList.add("active");
    }
  }
}
